import React from 'react';
import { useChangelogUpdate } from './useChangelogUpdate';

export const withChangelogData = (Component) => (props) => {
  const { isChangelogVisited, visitChangelog } = useChangelogUpdate();

  return <Component isChangelogVisited={isChangelogVisited} onClick={visitChangelog} {...props} />;
};
